// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "psh/js/" + chunkId + "-legacy." + {"60":"c0549942","369":"1aa9189d","435":"607df95f","454":"9a3b7a83","729":"63798bd0","831":"e8b5b281"}[chunkId] + ".js";
};